import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import i18n from './language'
// import ElementUI from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css'

// ElementUI按需引入部分组件
import {
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Carousel,
  CarouselItem,
  Upload
} from 'element-ui';

Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Upload)

Vue.prototype.axios = axios
Vue.config.productionTip = false
window.Vue = require('vue')
// Vue.use(ElementUI)

router.afterEach((to) => {
  if (to.name === 'Service') {
    document.title = to.meta.title; // 设置为 '万唐'
  } else {
    document.title = '深圳市米饭儿数据科技有限公司'; // 其他情况
  }
})

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
